import { ReportDetails } from 'MedicalReport/getters/__types__/report-details'
import { MedicalReportState } from 'MedicalReport/__types__/state'

export default {
  getReportDetails(state: MedicalReportState): ReportDetails | null {
    if (!state.medicalReport) return null
    return state.medicalReport
  },
}
